export const NAV_BAR_HEIGHT_CSS_VAR = '--uicomponents-global-nav-height';
export const NAV_BAR_HEIGHT = `var(${NAV_BAR_HEIGHT_CSS_VAR}, 54px)`;
export const GLOBAL_NAV_HEIGHT_CSS_VAR = '--global-nav-height';
// Navigation's published height, or 0 when nav is absent (headless/immersive).
export const GLOBAL_NAV_HEIGHT = `var(${GLOBAL_NAV_HEIGHT_CSS_VAR}, 0px)`;
export const TABS_ACTIVATE_TRANSITION_TIMING = '200ms';
export const DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE = 'data-transitional-component';